define('app/views/scheme_url_redirect_view',['app/setup'], function(takhfifan) {

  takhfifan.schemeUrlRedirectView = takhfifan.BaseView.extend({
    initialize: function() {
     var _this = this;
     this.cookie_redirect_scheme_prefix = 'redirect_scheme_prefix';
     var url_scheme = $.cookie(this.cookie_redirect_scheme_prefix);
     if(url_scheme && url_scheme!='') {
       address = window.location.href;
       address = address.replace("https",url_scheme);
       address = address.replace("http",url_scheme);
       $.cookie(this.cookie_redirect_scheme_prefix, '', {
         path: '/',
         domain:  document.domain,
         expires: 1
       });
       _this.openAppRedirectButton(address);
       window.location.href = address;
     }
   },

   openAppRedirectButton: function(address) {
     $('.wrapper').remove();
     $('.footer').remove();
     $('body').prepend('<div class="app-redirect-btn-contianer">'+
     '<img src="/skin/frontend/v3/default/images/modal-logo.png" alt="" width="70">'+
     '<a class="app-redirect-btn btn btn-green" href="'+address+'"'+
     '>برای بازگشت به اپلیکیشن اینجا کلیک کنید</a></div>');
   }
  });
});

